<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-syringe"></i> Vacina
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div class="col-md-4" :class="{'has-danger': $v.model.nome.$error }">
                                    <label>Nome da vacina*</label>
                                    <input
                                            type="text"
                                            maxlength="100"
                                            class="form-control"
                                            v-model="model.nome"
                                    />
                                </div>
                                <div class="col-md-4" :class="{'dropdown-has-error': $v.model.tipo.$error }">
                                    <label>Tipo*</label>
                                    <dw-select :options="tipos"
                                               v-model="model.tipo"
                                               opt-text="nome"
                                               placeholder="Selecione o tipo">
                                        <option value="0" selected disabled>Selecione o tipo</option>
                                    </dw-select>
                                </div>
                                <div class="col-md-4">
                                    <label>Responsável</label>
                                    <input
                                            type="text"
                                            maxlength="150"
                                            class="form-control"
                                            v-model="model.responsavel"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4" :class="{'has-danger': $v.model.data.$error }">
                                    <label>Data*</label>
                                    <input-datepicker
                                            :disabled="false"
                                            :readonly="false"
                                            :group="false"
                                            :autoclose="true"
                                            v-model="model.data"
                                    ></input-datepicker>
                                </div>

                                <div class="col-md-4" :class="{'has-danger': $v.model.peso.$error }">
                                    <label>Peso em kg*</label>
                                    <input
                                            v-model="model.peso"
                                            class="form-control"
                                    >
                                </div>

                                <div class="col-md-4" :class="{'has-danger': $v.model.data_proxima.$error }">
                                    <label>Data da próxima vacina*</label>
                                    <input-datepicker
                                            :disabled="false"
                                            :readonly="false"
                                            :group="false"
                                            :autoclose="true"
                                            v-model="model.data_proxima"
                                    ></input-datepicker>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                    :to="{name: 'list-vaccines-pet', params: {idCliente: this.$route.params.idCliente, id: this.$route.params.id}}"
                                    class="btn btn-link">Cancelar
                            </router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import Facade from "../../../facade/facade";
    import {
        required,
        maxLength,
        minLength,
        withParams
    } from "vuelidate/lib/validators";
    import {
        isNotUndefinedOrNullOrEmptyOrZero,
        isUndefinedOrNullOrEmpty
    } from "@/services/string";
    import Collections from "@/helpers/collections";
    import Select2 from "../../../components/Input/Select2";


    const facade = new Facade();

    export default {
        components: {Select2},
        data() {
            return {
                model: {
                    nome: '',
                    tipo: 0,
                    responsavel: '',
                    peso: '0,00',
                    data: moment().format("YYYY-MM-DD"),
                    data_proxima: moment().format("YYYY-MM-DD"),
                },
                tipos: []
            }

        },
        validations() {
            return {
                model: {
                    nome: {
                        required,
                        maxLength: maxLength(150),
                        minLength: minLength(2)
                    },
                    tipo: {
                        required,
                        isNotUndefinedOrNullOrEmptyOrZero
                    },
                    data: {
                        required
                    },
                    peso: {
                        required,
                        isValid(value) {
                            return !(value === undefined || value === null || value === '' || value === '0' || value === '0,00');
                        }
                    },
                    data_proxima: {
                        required
                    },
                }
            };
        },
        watch: {
            "model.peso"() {
                let vm = this;
                let regex = /^[0-9]\d{0,2}(,\d{0,2})?$/
                if (!regex.test(vm.model.peso)) {
                    vm.model.peso = vm.model.peso.slice(0, -1)
                }
            }
        },
        methods: {
            async save() {
                let vm = this;

                if (this.$v.model.$invalid) {
                    this.$v.model.$touch();
                    this.$notify.warning(
                        "Atenção!",
                        "Verifique se todos os campos estão preenchidos corretamente."
                    );
                    return;
                }

                this.$loading.show(true);

                if (vm.model.id) {
                    let ret = facade.updateVaccine(vm.model);
                    ret.then(vaccine => {
                        this.$router.push({
                            name: 'list-vaccines-pet',
                            params: {idCliente: this.$route.params.idCliente, id: this.$route.params.id}
                        });
                        this.$loading.show(false);
                    }).catch(e => {
                        e.forEach((item) => {
                            this.$notify.error(item.field, item.message);
                        });
                        this.$loading.show(false);
                    });
                } else {
                    try {
                        let ret = facade.createVaccine(vm.model, this.$route.params.id);
                        ret.then(vaccine => {
                            this.$router.push({
                                name: 'list-vaccines-pet',
                                params: {idCliente: this.$route.params.idCliente, id: this.$route.params.id}
                            });
                            this.$loading.show(false);
                        }).catch(e => {
                            e.forEach((item) => {
                                this.$notify.error(item.field, item.message);
                            });
                            this.$loading.show(false);
                        });
                    } catch (e) {
                        e.forEach(item => {
                            this.$notify.error(item.field, item.message);
                        });
                        this.$loading.show(false);
                    }
                }
            },
            throwError(e) {
                this.$notify.error("Erro!", e);
            },
            setData(vaccine) {
                let vm = this;
                if (vaccine !== undefined && vaccine !== null) {
                    vaccine.peso = vaccine.peso.replace('.', ',');
                    this.model = vaccine;
                }

                vm.tipos = Collections.tiposVacina;
            }
        },
        async beforeRouteEnter(to, from, next) {
            const vm = this;
            Promise.all([
                (to.params.idVacina ? facade.getVaccine(to.params.idVacina) : null)
            ]).then(response => {
                next(vm => vm.setData((response[0] != null ? response[0].data.data : null)));
            }).catch(e => {
                next(vm => vm.setData());
            });
        },
    };
</script>



// WEBPACK FOOTER //
// Form.vue?831c690a